import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommunitySpaces from './Home/CommunitySpaces';

const MyCollections = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.token);

  if (!token) {
    navigate('/login');
    return null;
  }

  return (
    <CommunitySpaces
      myCollectionsMode={true}
      pageTitle="My Collections"
    />
  );
};

export default MyCollections;
